import AudioPlayer from '@/util/audio';
import Constant from '@/lib/constant';
import { hasPermission } from '@/util/index';

const baseRole = Constant.RoleList;
export const PENDING_PRESCRIPTION_REMINDER_KEY = 'PENDING_PRESCRIPTION_REMINDER';

const prescriptionReminderAudioPlayer = new AudioPlayer({
  src: require('@/assets/audio/prescription-remind.mp3'),
  loopCount: 1
});

export const markPendingPrescriptionReminder = () => {
  localStorage.setItem(PENDING_PRESCRIPTION_REMINDER_KEY, String(Date.now()));
};

export const hasPendingPrescriptionReminder = () => {
  return !!localStorage.getItem(PENDING_PRESCRIPTION_REMINDER_KEY);
};

export const clearPendingPrescriptionReminder = () => {
  localStorage.removeItem(PENDING_PRESCRIPTION_REMINDER_KEY);
};

export const playPendingPrescriptionReminder = () => {
  const roles = [baseRole.b, baseRole.f];
  if (hasPendingPrescriptionReminder() && hasPermission(roles)) {
    prescriptionReminderAudioPlayer.play();
  }
};
